import debugLib from 'debug';
import * as R from 'ramda';

import { APPLE_MACHINE_NAME } from '../../../../shared/constants/adPartnerConstants';
import { GET_ORGANIZATIONS, RESET_SETTINGS, UPLOAD_CREDENTIAL } from '../actions/AppleSearchAdsActions';
import { GET_AD_ACCOUNT_STATUS } from '../actions/SANPartnerActions';
import { reducerWrapper } from '../support/utils';

// The APPLE_SAVE_CONFIG action is used in the AdPartnerReducer, not here

const debug = debugLib('AppleSearchAdsReducer');

type State = {
  isCertificateSaved: boolean;
  isKeySaved: boolean;
  organizations: any[];
  adAccountStatus: any;
  loading: boolean;
  error: any;
};

const INIT_STATE = {
  isCertificateSaved: false,
  isKeySaved: false,
  organizations: [],
  adAccountStatus: {},
  loading: false,
  error: null,
};

function Handler(state = INIT_STATE, action) {
  debug('Receive action type', action.type);

  switch (action.type) {
    case UPLOAD_CREDENTIAL.response:
      const nextState = action.data;
      nextState.loading = false;
      return R.merge(state, nextState);

    case GET_ORGANIZATIONS.response:
      const { organizations } = action.data;
      return R.merge(state, {
        organizations,
        loading: false,
      });

    case GET_AD_ACCOUNT_STATUS.response:
      const adAccountStatus = R.path([APPLE_MACHINE_NAME], action.data) || {};
      return R.merge(state, {
        adAccountStatus,
      });

    case RESET_SETTINGS.response:
      return INIT_STATE;

    default:
      return state;
  }
}

const AppleSearchAds = reducerWrapper<State, any>(INIT_STATE, Handler as any, {
  request: [UPLOAD_CREDENTIAL, GET_ORGANIZATIONS, GET_AD_ACCOUNT_STATUS],
  error: [UPLOAD_CREDENTIAL, GET_ORGANIZATIONS, GET_AD_ACCOUNT_STATUS],
  resetOn: ['APP_CHANGE'],
});

export default AppleSearchAds;
